
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import * as reportCss from './DetailReport.css.js';
import { nvl } from 'utils/nvl';

// 카운트 함수
const countOperationValue = (auths, eventCnt, etcValues) => {
  return (
    auths.map(auth => {
      if (auth.level === 2) {
        return nvl(eventCnt[auth.authIdx], 0)
      }
      else {
        return 0
      }
    }).reduce((a, b) => a + b, 0) + etcValues
  )
}

const ReportEvent = ({ auths, beginDate, endDate, setReportMap }) => {
  const history = useHistory();
  const cancellationToken = useCancellationToken();
  const [ eventCnt, setEventCnt ] = useState(null);
  const [ etcValuesByType, setEtcValuesByType ] = useState({
                                                            gas: 0,
                                                            hf: 0,
                                                            ph: 0,
                                                            leakage: 0,
                                                            etc: 0
                                                          })
  const [ etcValuesByAuth, setEtcValuesByAuth ] = useState(
    auths.reduce((map, obj) => { if(obj.level === 2) map[obj.authIdx] = 0; return map; }, {'etc': 0})
  )
  const [ detail, setDetail ] = useState({});

  const eventCount = useCallback(async (beginDate, endDate) => {
    customAxiosGetFunction(history, '/api/event/eventCnt', {params: {'beginDate': beginDate, 'endDate': endDate}})
      .then(response => {
        setEventCnt(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])

  // 구분별 기타값 세팅
  const handleChangeSetEtcByType = useCallback((key, value) => {
    setEtcValuesByType((etcValuesByType) => {
      return {
        ...etcValuesByType,
        [key]: Number(value)
      }
    })
  }, [etcValuesByType])

  // 팀별 기타값 세팅 - 구분결 기타도 하나의 팀으로 간주
  const handleChangeSetEtcByAuth = useCallback((key, value) => {
    setEtcValuesByAuth((etcValuesByType) => {
      return {
        ...etcValuesByType,
        [key]: Number(value)
      }
    })
  }, [etcValuesByAuth])

  const handleChangeDetail = useCallback((x, value) => {
    setDetail(detail => {
      return {
        ...detail,
        [x]: value
      }
    })
  }, [])

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return
    }

    eventCount(beginDate, endDate);
  }, [beginDate, endDate, cancellationToken])

  useEffect(() => () => cancellationToken.cancel(), []);

  
  // 레포트맵 세팅
  useEffect(() => {
    if (eventCnt) {
      setReportMap((reportMap) => {
        return {
          ...reportMap,
          'event': auths.reduce((map, obj) => { 
            if(obj.level === 2) {
              map[obj.authNm] = {
                'gas': nvl(eventCnt.gas[obj.authIdx], 0),
                'hf': nvl(eventCnt.hf[obj.authIdx], 0),
                'ph': nvl(eventCnt.ph[obj.authIdx], 0),
                'leakage': nvl(eventCnt.leakage[obj.authIdx], 0),
                'etc': etcValuesByAuth[obj.authIdx],
              };
            }

            return map;
          }, {
               'etc': {
                 ...etcValuesByType, 
                 'etc': etcValuesByAuth.etc,
                },
                'sum': {
                  'gas': countOperationValue(auths, eventCnt.gas, etcValuesByType.gas),
                  'hf': countOperationValue(auths, eventCnt.hf, etcValuesByType.hf),
                  'ph': countOperationValue(auths, eventCnt.ph, etcValuesByType.ph),
                  'leakage': countOperationValue(auths, eventCnt.leakage, etcValuesByType.leakage),
                  'etc': countOperationValue(auths, etcValuesByAuth, etcValuesByAuth.etc),
                }
              }),
          'detail': {
            ...reportMap.detail,
            'event': Object.keys(detail).map(x => { return detail[x] })
          }
        }
      })
    }
  }, [eventCnt, etcValuesByType, etcValuesByAuth, detail])

  if (!auths || !eventCnt) {
    return null;
  }

  return (
    <>
      <reportCss.EventTitleBar>
        <span>4. 이벤트 발생현황</span>
      </reportCss.EventTitleBar>
      <reportCss.EventContent>
        <div className="mainContent">
          <table>
            <thead>
              <tr>
                <th>구분</th>
                <th>복합가스감지기</th>
                <th>HF감지기</th>
                <th>우수로</th>
                <th>H<sub>2</sub>SO<sub>4</sub> Tank</th>
                <th>기타</th>
              </tr>
            </thead>
            <tbody>
            {
                auths.map(auth => {
                  if (auth.level === 2) {
                    return (
                      <tr key={auth.authIdx}>
                        <td>{ auth.authNm }</td>
                        <reportCss.EventContentTd value={nvl(eventCnt.gas[auth.authIdx], 0)}>{ nvl(eventCnt.gas[auth.authIdx], 0) }</reportCss.EventContentTd>
                        <reportCss.EventContentTd value={nvl(eventCnt.hf[auth.authIdx], 0)}>{ nvl(eventCnt.hf[auth.authIdx], 0) }</reportCss.EventContentTd>
                        <reportCss.EventContentTd value={nvl(eventCnt.ph[auth.authIdx], 0)}>{ nvl(eventCnt.ph[auth.authIdx], 0) }</reportCss.EventContentTd>
                        <reportCss.EventContentTd value={nvl(eventCnt.leakage[auth.authIdx], 0)}>{ nvl(eventCnt.leakage[auth.authIdx], 0) }</reportCss.EventContentTd>
                        <reportCss.EventContentTd value={etcValuesByAuth[auth.authIdx]}>
                          <input type="text" 
                                 className="inputNumber" 
                                 defaultValue={etcValuesByAuth[auth.authIdx]}
                                 onChange={({target}) => { handleChangeSetEtcByAuth(auth.authIdx, target.value) }} />
                        </reportCss.EventContentTd>
                      </tr>
                    )
                  }
                })
              }
              <tr>
                <td>기타</td>
                <reportCss.EventContentTd value={etcValuesByType.gas}>
                  <input type="text" 
                         className="inputNumber" 
                         defaultValue={etcValuesByType.gas}
                         onChange={({target}) => { handleChangeSetEtcByType('gas', target.value) }} />
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={etcValuesByType.hf}>
                  <input type="text" 
                         className="inputNumber" 
                         defaultValue={etcValuesByType.hf}
                         onChange={({target}) => { handleChangeSetEtcByType('hf', target.value) }} />
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={etcValuesByType.ph}>
                  <input type="text" 
                         className="inputNumber" 
                         defaultValue={etcValuesByType.ph}
                         onChange={({target}) => { handleChangeSetEtcByType('ph', target.value) }} />
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={etcValuesByType.leakage}>
                  <input type="text" 
                         className="inputNumber" 
                         defaultValue={etcValuesByType.leakage}
                         onChange={({target}) => { handleChangeSetEtcByType('leakage', target.value) }} />
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={etcValuesByType.etc}>
                  <input type="text" 
                         className="inputNumber" 
                         defaultValue={etcValuesByAuth.etc}
                         onChange={({target}) => { handleChangeSetEtcByAuth('etc', target.value) }} />
                </reportCss.EventContentTd>
              </tr>
              <tr>
                <td>계</td>
                <reportCss.EventContentTd value={countOperationValue(auths, eventCnt.gas, etcValuesByType.gas)}>
                  {countOperationValue(auths, eventCnt.gas, etcValuesByType.gas)}
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={countOperationValue(auths, eventCnt.hf, etcValuesByType.hf)}>
                  {countOperationValue(auths, eventCnt.hf, etcValuesByType.hf)}
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={countOperationValue(auths, eventCnt.ph, etcValuesByType.ph)}>
                  {countOperationValue(auths, eventCnt.ph, etcValuesByType.ph)}
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={countOperationValue(auths, eventCnt.leakage, etcValuesByType.leakage)}>
                  {countOperationValue(auths, eventCnt.leakage, etcValuesByType.leakage)}
                </reportCss.EventContentTd>
                <reportCss.EventContentTd value={countOperationValue(auths, etcValuesByAuth, etcValuesByAuth.etc)}>
                  {countOperationValue(auths, etcValuesByAuth, etcValuesByAuth.etc)}
                </reportCss.EventContentTd>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="subContent">
          <table>
            <thead>
              <tr>
                <th>이벤트 특기사항 (발생일시, 내용, 조치사항, pending사항 등)</th>
              </tr>
            </thead>
            <tbody>
              {
                [...Array(auths.length + 2).keys()].map((x) => {
                  return (
                    <tr key={`detail_${x}`}>
                      <td><input type="text" 
                                 className="inputText" 
                                 onChange={({target}) => { handleChangeDetail(x, target.value) }} /></td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </reportCss.EventContent>
    </>
  )
}

export default React.memo(ReportEvent);